import {
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { DacScenariosRepository } from '@/store/dac-scenarios-state/dac-scenarios-state.repository';
import { Scenario } from '@/types/scenarios.types';

interface IGetDacScenariosDataTableStructureProps {
  store: DacScenariosRepository;
  createAction?: () => void;
  rowActionsFn?: (target: Scenario) => DataTableRowActions;
  enableServerActions: boolean;
  serverQuery?: DataTableServerQuery;
}

export const getDacScenariosDataTableStructure = ({
  store,
  createAction,
  rowActionsFn,
  enableServerActions,
  serverQuery,
}: IGetDacScenariosDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };

  const codeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.table.code',
    accessorKey: 'code',
    variant: DataTableColumnVariant.TEXT,
  };
  const nomColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.table.nom',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const descriptionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.table.description',
    accessorKey: 'description',
    variant: DataTableColumnVariant.TEXT,
  };

  const modeEvaluationFinalColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.dacScenarios.table.modeEvaluationFinal',
    accessorKey: 'modeEvaluationFinal',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value, row: Scenario) => {
      return {
        value: row.modeEvaluationFinal?.description || '-',
      };
    },
  };

  const creationDateColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'settings.dacScenarios.table.creationDate',
    accessorKey: 'creationDate',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  return {
    singular: 'settings.dacScenarios.table.singular',
    plural: 'settings.dacScenarios.table.plural',
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    columns: [idColumn, codeColumn, nomColumn, descriptionColumn, modeEvaluationFinalColumn, creationDateColumn],
    target: row => {
      store.set('dto', {
        nom: row.nom,
        description: row.description,
        code: row.code,
        modePassationIds: row.modePassationIds,
      });
      store.set('response', row);
    },
    createAction,
    rowActionsFn,
    enableServerActions,
    serverQuery,
    rowRenderOverride: (row: Scenario) => {
      return {
        class: row.active ? '' : 'opacity-50',
      };
    },
  };
};
